<template>
    <b-overlay :show="show" rounded="sm">
        <span>
            <b-card no-body>
                <b-card-header>
                    <b-row>
                        <b-col sm="12">
                            <h3>Tutorial - {{ form.titulo }}</h3>
                        </b-col>
                    </b-row>
                </b-card-header>
                <b-card-body>
                    <b-card-group deck v-for="(item, index) in itens" :key="index">
                        <b-card bg-variant="secondary" text-variant="white" style="margin-bottom: 1rem;"
                            class="text-center">
                            <b-card-text v-if="item.tipo === 'TE'">
                                <span v-html="form.texto[index].texto"></span>
                            </b-card-text>
                            <b-card-text v-if="item.tipo === 'AR'">
                                <div v-for="file in form.files[index].files" :key="file.id">
                                    <b-button variant="primary" size="lg" style="margin-bottom: 1rem;"
                                        @click="abrirDocumento(file.caminho)">
                                        Arquivo</b-button>
                                </div>
                            </b-card-text>
                            <b-card-text v-if="item.tipo === 'SV'">
                                <iframe width="560" height="315" :src="form.video_url[index].video_url"
                                    title="YouTube video player" frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen></iframe>
                            </b-card-text>
                            <b-card-text v-if="item.tipo === 'UV'">
                                <video v-if="form.video_upload[index].url_video" width="320" height="240" controls>
                                    <source :src="form.video_upload[index].url_video" type="video/mp4">
                                </video>
                            </b-card-text>
                        </b-card>
                    </b-card-group>
                </b-card-body>
            </b-card>
        </span>
    </b-overlay>
</template>

<script>
import Vue from 'vue'
import miniToastr from 'mini-toastr'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import FileUpload from 'vue-upload-component'


miniToastr.init()

const formShape = {
    titulo: '',
    status: true,
    item: null,
    texto: [],
    files: [],
    video_url: [],
    video_upload: [],
    documentos: []
}

export default {
    components: {
        FileUpload,
    },
    mixins: [validationMixin],
    validations: {

    },
    created() {
        this.loadTutorial()
    },
    data() {
        return {
            itens: [],
            form: Object.assign({}, formShape),
            show: false
        }
    },
    computed: {
        //
    },
    watch: {
        //
    },
    methods: {
        loadTutorial() {
            this.show = true
            Vue.http.get('api/tutorial?situacao=1').then(response => {
                var dat = response.body.data.data[0]
                Vue.http.get('api/tutorial/' + dat.id).then(response => {
                    var dados = response.body.data[0]

                    if (dados.textos.length > 0) {
                        for (let i = 0; i < dados.textos.length; i++) {
                            this.itens[dados.textos[i].ordem] = {
                                tipo: 'TE'
                            }

                            this.form.texto[dados.textos[i].ordem] = {
                                texto: dados.textos[i].texto,
                                ordem: dados.textos[i].ordem
                            }
                        }
                    }

                    if (dados.arquivos.length > 0) {
                        var arquivos = []
                        for (let i = 0; i < dados.arquivos.length; i++) {
                            this.itens[dados.arquivos[i].ordem] = {
                                tipo: 'AR'
                            }
                        }

                        for (let i = 0; i < this.itens.length; i++) {
                            for (let e = 0; e < dados.arquivos.length; e++) {
                                if (dados.arquivos[e].ordem == i) {

                                    arquivos.push({
                                        id: e,
                                        caminho: dados.arquivos[e].arquivo,
                                        name: 'Documento',
                                        old: true,
                                        ordem: i
                                    })

                                    this.form.files[i] = {
                                        files: arquivos,
                                        ordem: i
                                    }
                                }
                            }
                            var arquivos = []
                        }
                    }

                    if (dados.url_videos.length > 0) {
                        for (let i = 0; i < dados.url_videos.length; i++) {
                            this.itens[dados.url_videos[i].ordem] = {
                                tipo: 'SV'
                            }

                            this.form.video_url[dados.url_videos[i].ordem] = {
                                video_url: dados.url_videos[i].url_video,
                                ordem: dados.url_videos[i].ordem
                            }
                        }
                    }

                    if (dados.upload_videos.length > 0) {
                        for (let i = 0; i < dados.upload_videos.length; i++) {

                            this.itens[dados.upload_videos[i].ordem] = {
                                tipo: 'UV'
                            }
                            this.form.video_upload[dados.upload_videos[i].ordem] = {
                                video_upload: dados.upload_videos[i].upload_video,
                                ordem: dados.upload_videos[i].ordem,
                                url_video: process.env.ROOT_API1 + dados.upload_videos[i].upload_video
                            }
                        }
                    }

                    this.form.titulo = dados.titulo
                    this.show = false
                })
            })
        },
        abrirDocumento(item) {
            window.open(process.env.ROOT_API1 + item, '_blank')
        },
    }
}
</script>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>

<style>
.adicionarItem {
    margin-top: 5%;
}

.botoes-secao {
    text-align: right;
}

img {
    max-width: 500px;
}

.bg-secondary {
    background-color: #b0b6b6 !important;
    border-color: #b9c8c9 !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/site/interna/tutoriais/TutorialAtivo.vue